module.exports = __webpack_public_path__ + "static/img/rule-mfood.a609aabc.png";